module.exports = __webpack_public_path__ + "static/spamonkeys-logo.6a0ce261.svg";